import GMaps from './GMaps'
import gpsImage from './img/icn-user-gps.svg'
import pinImage from './img/icn-local-pin.svg'
import carImage from './img/car.png'

const config = {
  originMarkerImage: pinImage,
  destinytMarkerImage: pinImage,
  gpsMarkerImage: gpsImage,
  drivertMarkerImage: carImage,
  clientMarkerImage: gpsImage
}

export default {
  install (Vue) {
    Vue.$gmaps = new GMaps(config)
    Vue.prototype.$gmaps = new GMaps(config)
  }
}
